import portalApi from "../api/apiSlice";

const quizApi = portalApi.injectEndpoints({
  endpoints: (builder) => ({
    getQuizes: builder.query({
      query: () => "quizzes",
    }),

    getSingleQuiz: builder.query({
      query: (quizId) => `quizzes/${quizId}`,
    }),

    getVideoQuiz: builder.query({
      query: (quizId) => `quizzes?video_id=${quizId}`,
    }),

    addQuiz: builder.mutation({
      query: (quiz) => ({
        url: "quizzes",
        method: "POST",
        body: quiz,
      }),

      onQueryStarted: async (quiz, { dispatch, queryFulfilled }) => {
        try {
          const { data } = await queryFulfilled;

          dispatch(
            portalApi.util.updateQueryData(
              "getQuizes",
              undefined,
              (prevquizes) => {
                return [...prevquizes, data];
              }
            )
          );
        } catch {}
      },
    }),

    editQuiz: builder.mutation({
      query: (quiz) => ({
        url: `quizzes/${quiz.id}`,
        method: "PATCH",
        body: quiz,
      }),

      onQueryStarted: async (quiz, { dispatch, queryFulfilled }) => {
        try {
          const { data } = await queryFulfilled;

          dispatch(
            portalApi.util.updateQueryData(
              "getQuizes",
              undefined,
              (prevQuizes) => {
                return prevQuizes.map((prevQuiz) => {
                  if (prevQuiz.id === quiz.id) {
                    return data;
                  }
                  return prevQuiz;
                });
              }
            )
          );

          dispatch(
            portalApi.util.updateQueryData("getSingleQuiz", quiz.id, () => {
              return data;
            })
          );
        } catch {}
      },
    }),

    deleteQuiz: builder.mutation({
      query: (quizId) => ({
        url: `quizzes/${quizId}`,
        method: "DELETE",
      }),

      onQueryStarted: async (quizId, { dispatch, queryFulfilled }) => {
        try {
          await queryFulfilled;
          dispatch(
            portalApi.util.updateQueryData(
              "getQuizes",
              undefined,
              (prevQuizes) => {
                return prevQuizes.filter((prevQuiz) => {
                  return prevQuiz.id !== quizId;
                });
              }
            )
          );
        } catch {}
      },
    }),
  }),
});

export const {
  useGetSingleQuizQuery,
  useEditQuizMutation,
  useDeleteQuizMutation,
  useGetQuizesQuery,
  useGetVideoQuizQuery,
  useAddQuizMutation,
} = quizApi;
